import React from "react";

const BizzaboIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.4438 18.4562C32.8188 16.875 33.6 14.9937 33.6 13C33.6 5.525 28 0 16 0C9.11875 0 4 2 4 2L5.8 6.8C5.8 6.8 9.48125 4.8 16 4.8C22.5188 4.8 28.8 6.675 28.8 13C28.8 13.95 28.55 14.7375 28.1063 15.4C23.2063 11.6437 16.925 9.40625 12 9.40625C9.20625 9.40625 5 10.8125 5 14.8C5 21.1812 14.8188 23 20 23C22.9125 23 25.525 22.3687 27.6688 21.3062C29.6625 23.4687 31 26.1063 31 29.2C31 33.95 26 35 23.2 35C15.6 35 11.2063 29.8687 9.8 26.8L5.2 28V38.8H10V34.8C10 34.8 14.825 40 23.2 40C31.2063 40 36 35.2875 36 29.2C36 25.1438 34.1938 21.4875 31.4438 18.4562ZM10 15.2C10 13.1812 17.4563 14.1812 23.4875 17.9187C17.925 18.975 10 16.975 10 15.2Z",
  fill: "#1A1A1A"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BizzaboIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;